<div class="footer">
	<div class="footer__wrapper gap-font--caption">
		<img
			class="footer__logo"
			ngSrc="/assets/logo/accesso-passport-logo.svg"
			width="435"
			height="211"
			[alt]="accessoLogoAltText"
		/>
		<div class="footer__text">
			<div class="footer__copyright">© {{ buildTimestamp }} accesso Technology Group, PLC.</div>
			<div class="footer__version">{{ 'common.version' | locale }}: {{ buildVersion }}</div>
		</div>
	</div>
</div>
